let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dNXO5")).then(() => parcelRequire('hc8vA'));